// Disable max class per file due to form validation classes
/* eslint-disable max-classes-per-file */

import { IsDate, IsInt, IsOptional, IsString, ValidateNested } from 'class-validator';

class ContractorForm {
  @IsOptional()
  @IsString()
  public readonly name: string | null;

  @IsOptional()
  @IsString()
  public readonly address: string | null;

  @IsOptional()
  @IsString()
  public readonly city: string | null;

  constructor(params: ContractorForm) {
    this.name = params.name;
    this.address = params.address;
    this.city = params.city;
  }
}

class ResidentEngineerForm {
  @IsOptional()
  @IsString()
  public readonly name: string | null;

  @IsOptional()
  @IsString()
  public readonly phone: string | null;

  constructor(params: ResidentEngineerForm) {
    this.name = params.name;
    this.phone = params.phone;
  }
}

export class ContractForm {
  @IsOptional()
  @IsString()
  public readonly district: string | null;

  @IsOptional()
  @IsString()
  public readonly ea: string | null;

  @IsInt()
  public readonly number: number;

  @ValidateNested()
  public readonly contractor: ContractorForm;

  @IsOptional()
  @IsString()
  public readonly county: string | null;

  @IsOptional()
  @IsString()
  public readonly pmBackPreCityCr: string | null;

  @IsOptional()
  @IsString()
  public readonly descriptionOfWork: string | null;

  @IsOptional()
  @IsString()
  public readonly locationDescription: string | null;

  @IsOptional()
  @ValidateNested()
  public readonly residentEngineer: ResidentEngineerForm;

  @IsOptional()
  @IsString()
  public readonly federalAidLocation: string | null;

  @IsOptional()
  @IsDate()
  public readonly bidOpenDate: Date | null;

  @IsOptional()
  @IsDate()
  public readonly awardDate: Date | null;

  @IsOptional()
  @IsDate()
  public readonly approvalDate: Date | null;

  @IsOptional()
  @IsDate()
  public readonly workMustStartDate: Date | null;

  @IsOptional()
  @IsDate()
  public readonly estCompDate: Date | null;

  @IsOptional()
  @IsDate()
  public readonly actualCompDate: Date | null;

  @IsOptional()
  @IsDate()
  public readonly acceptanceDate: Date | null;

  @IsOptional()
  @IsDate()
  public readonly suspendDate: Date | null;

  @IsOptional()
  @IsDate()
  public readonly lastEstDate: Date | null;
}
